import MuiForm from "rjsf-material-ui";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import { clean } from "../HelperFunctions";
import { isEmpty } from "../../../utils/index";
import * as GenSettingActions from "../../../store/actions/GenSetting";
import * as CityPropertyActions from "../../../store/actions/CityProperty";
import Button from "sushiweb/Button";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  button: {
    marginTop: "1.25rem",
    marginBottom: "1.25rem",
    className: "shushi-btn",
    width: "12.5rem",
    height: "2.75rem",
    style: "position: absolute; right: 0",
  },
}));

const formschema = {
  type: "object",
  required: ["rule_name", "priority", "order_selector", "levels"],
  properties: {
    rule_name: {
      type: "string",
      title: "Rule Name",
    },
    priority: {
      type: "integer",
      title: "Priority",
    },
    order_selector: {
      type: "object",
      title: "Order Selector",

      properties: {
        user_market_segment: {
          type: "integer",
        },
        total_order_value: {
          type: "number",
        },
        bypassed_order: {
          type: "boolean",
        },
      },
    },
    levels: {
      type: "array",
      title: "Levels",
      items: {
        type: "object",
        required: ["priority", "activation", "actions"],
        properties: {
          priority: {
            type: "integer",
            title: "Priority",
          },
          activation: {
            type: "object",
            title: "Activation",
            default: {},
            properties: {
              remaining_assignment_time: {
                type: "number",
                title: "remaining_assignment_time",
              },
              cell_assignment_time: {
                type: "number",
                title: "cell_assignment_time",
              },
            },
          },
          actions: {
            type: "object",
            title: "actions",
            default: {},
            properties: {
              self: {
                type: "object",
                properties: {
                  assignment_radius_multiplier: {
                    type: "number",
                    title: "assignment_radius_multiplier",
                  },
                  cost_multiplier: {
                    type: "number",
                    title: "cost_multiplier",
                  },
                  angle_multiplier: {
                    type: "number",
                    title: "angle_multiplier",
                  },
                  detour_multiplier: {
                    type: "number",
                    title: "detour_multiplier",
                  },
                  order_ready_threshold_delta: {
                    type: "number",
                    title: "order_ready_threshold_delta",
                  },
                  breach_threshold: {
                    type: "number",
                    title: "breach_threshold",
                  },
                  first_drop: {
                    type: "boolean",
                  },
                  delay_assignment_config: {
                    type: "object",
                    title: "delay_assignment_config",
                    properties: {
                      disable_delayed_assignment: {
                        type: "boolean",
                        title: "disable_delayed_assignment",
                      },
                    },
                  },
                },
              },
              others: {
                type: "object",
                title: "others",
                properties: {
                  segment_batching_config: {
                    type: "array",
                    title: "segment_batching_config",
                    items: {
                      type: "object",
                      properties: {
                        breach_threshold_delta: {
                          type: "number",
                          title: "breach_threshold_delta",
                        },
                        segment: {
                          type: "number",
                          title: "segment",
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};

const RuleFormModal = (props) => {
  const classes = useStyles();
  const {
    modalState,
    handleClose,
    finalConfig,
    ruleSchema,
    activeCityProperty,
    activeGenSetting,
  } = props;
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    setFormData(e.formData);
  };

  const handleSubmit = () => {
    // set new identifier to new Rule
    clean(formData);
    if (formData.levels == undefined || formData.levels == null) {
      formData.levels = [];
    }
    if (
      formData.order_selector == undefined ||
      formData.order_selector == null
    ) {
      formData.order_selector = {};
    }
    setFormData(formData);
    formData.is_new = true;
    formData.is_modified = true;
    // if city is selected then the new rule will go in cityproperty
    if (!isEmpty(activeCityProperty)) {
      formData.is_city_property = true;
    }
    // set activeRule redux store and update finalconfig
    props.setActiveRule(formData);
    finalConfig.push(formData);
    finalConfig.sort((a, b) =>
      a.priority < b.priority ? 1 : b.priority < a.priority ? -1 : 0
    );
    props.setFinalConfig({
      rules: finalConfig,
    });
    setFormData({});
    handleClose();
  };

  return (
    <div className="Rule-Form">
      <Dialog
        fullScreen
        open={!!modalState}
        onClose={handleClose}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="scroll-dialog-feature"
        aria-describedby="scroll-dialog-description"
      >
        <AppBar className={classes.appBar} color="transparent">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              <b>Add Rule</b>
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <MuiForm
            formData={formData}
            onChange={handleChange}
            onSubmit={handleSubmit}
            schema={!isEmpty(ruleSchema) ? ruleSchema : formschema}
          >
            <div style={{ float: "right" }}>
              <Button className={classes.button} size="compressed">
                {" "}
                {"Submit"}{" "}
              </Button>
            </div>
          </MuiForm>
        </DialogContent>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { GenSetting, CityProperty } = state;
  return {
    ruleSchema: GenSetting.ruleSchema,
    activeGenSetting: GenSetting.activeGenSetting,
    activeCityProperty: CityProperty.activeCityProperty,
    activeRule: GenSetting.activeRule,
    finalConfig: GenSetting.finalConfig,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setActiveRule: bindActionCreators(
      GenSettingActions.setActiveRule,
      dispatch
    ),
    setFinalConfig: bindActionCreators(
      GenSettingActions.setFinalConfig,
      dispatch
    ),
    setActiveGenSetting: bindActionCreators(
      GenSettingActions.setActiveGenSetting,
      dispatch
    ),
    setActiveCityProperty: bindActionCreators(
      CityPropertyActions.setActiveCityProperty,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RuleFormModal);
